module.exports = __webpack_public_path__ + "static/media/olivia-wilde-lose.d2c5253d.jpg";